import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { Icon } from "@iconify/react";
import { fields } from "../constants";
import { NewsTable } from "./NewsTable";
import { NewsPageHeading } from "./NewsPageHeading";
import { LatestNewsPageHeading } from "./LatestNewsPageHeading";
import { ArchivesNewsPageHeading } from "./ArchivesNewsPageHeading";
import { LatestNewsNextPage } from "./LatestNewsNextPage";
import { ArchivesNewsNextPage } from "./ArchivesNewsNextPage";

export const News = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Latest News Page Heading",
      key: "latestNewsPageHeading",
      children: <LatestNewsPageHeading/>
    }, 
    {
      label: "Archives News Page Heading",
      key: "archivesNewsPageHeading",
      children: <ArchivesNewsPageHeading/>
    },
    {
      label: "Page Content",
      key: "newsPageContent",
      children: <NewsTable/>
    },
    {
      label: "Latest News Next Page",
      key: "latestNewsNextPage",
      children: <LatestNewsNextPage/>
    },
    {
      label: "Archives News Next Page",
      key: "archivesNewsNextPage",
      children: <ArchivesNewsNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`/dedicated/corporate/media-centre?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
